import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import ChangePassword from "../../Pages/ChangePassword";
import ResetPassword from "../../Pages/ResetPassword";
import Sigin from "../../Pages/SignIn";
import { TokenValidation } from "../../Utils/authValidationUtils";
import "./style.css";
import { typography } from "../../Assets/typography";
import { colors } from "../../Assets/colors";
import justmoveinLogo from "../../Assets/icons/justmovein.svg";

const Navbar = (props) => {
  const [loginShow, setLoginShow] = useState(false);
  const [resetPassShow, setResetPassShow] = useState(false);
  const [changePass, setchangePass] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 844);

  const updateIsMobile = () => {
    setIsMobile(window.innerWidth <= 844);
  };

  useEffect(() => {
    window.addEventListener("resize", updateIsMobile);
    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  useEffect(() => {
    if (props.match.params.token) {
      setchangePass(true);
    }
  }, []);

  const { dashboard, isDashboardError } = props;

  const onLogout = () => {
    localStorage.clear();
    window.location.replace("https://www.moveinout.co.uk/");
  };
  const onLogoClick = () => {
    props.history.push("/");
    window.scroll(0, 0);
  };

  const isJustMovein = process.env.REACT_APP_MODE === "prod-justmovein";
  const isReallyMoving = process.env.REACT_APP_MODE === "prod-reallymoving";
  const isHomebox = process.env.REACT_APP_MODE === "prod-homebox";
  const isHousr = process.env.REACT_APP_MODE === "prod-housr";
  const isNotAnyPartner = !isJustMovein && !isReallyMoving && !isHomebox && !isHousr;

  return (
    <>
      <nav
        className="  mn-navbar-new "
        style={
          props.loginPage ? { backgroundColor: "rgba(249, 249, 249, 0.7)" } : {}
        }>
        {loginShow && (
          <Sigin onCross={setLoginShow} resetPass={setResetPassShow} />
        )}
        {resetPassShow && <ResetPassword onCross={setResetPassShow} />}
        {changePass && <ChangePassword onCross={setchangePass} />}

        {isReallyMoving && (
          <div className="d-flex align-items-center">
            <a
              href="https://www.reallymoving.com/"
              target="_blank"
              rel="noopener noreferrer">
              <img
                className={
                  isMobile ? "reallymoving-logo-mobile" : "reallymoving-logo"
                }
                src="https://media.umbraco.io/reallymoving2/mwpcygsj/rm-logo-25yrs-uncropped.svg"
                alt="ReallyMoving"
              />
            </a>

            <img
              className={
                isMobile ? "chapperone-logo-mobile" : "reallymoving-logo"
              }
              alt="MoveInOut"
              onClick={onLogoClick}
              src={require("../../Assets/images/Moveinout-logo.png")}
            />
          </div>
        )}
        {isJustMovein && (
          <div className="d-flex align-items-center">
            <img
              className={
                isMobile ? "reallymoving-logo-mobile" : "reallymoving-logo"
              }
              src={justmoveinLogo}
              alt="JustMoveIn"
            />

            <img
              className={
                isMobile ? "chapperone-logo-mobile" : "reallymoving-logo"
              }
              alt="MoveInOut"
              onClick={onLogoClick}
              src={require("../../Assets/images/Moveinout-logo.png")}
            />
          </div>
        )}
        {isHomebox && (
          <div className="d-flex align-items-center">
            <a
              href="https://www.homebox.co.uk/"
              target="_blank"
              rel="noopener noreferrer">
              <img
                className={
                  isMobile ? "reallymoving-logo-mobile" : "reallymoving-logo"
                }
                src={require("../../Assets/images/homeboxlogo.png")}
                alt="MoveInOut"
              />
            </a>
            <a
              href="https://app.moveinout.co.uk/getStarted"
              className="chapperone-logo-wrapper"
              target="_blank"
              rel="noopener noreferrer">
              <img
                className={
                  isMobile ? "chapperone-logo-mobile" : "reallymoving-logo"
                }
                alt="Homebox"
                onClick={onLogoClick}
                src={require("../../Assets/images/Moveinout-logo.png")}
              />
            </a>
          </div>
        )}
        {isHousr && (
          <div className="d-flex align-items-center">
            <a
              href="https://www.housr.co.uk/"
              target="_blank"
              rel="noopener noreferrer">
              <img
                className={
                  isMobile ? "reallymoving-logo-mobile" : "reallymoving-logo"
                }
                src={require("../../Assets/icons/housr-logo.png")}
                alt="MoveInOut"
              />
            </a>
            <a
              href="https://app.moveinout.co.uk/getStarted"
              className="chapperone-logo-wrapper"
              target="_blank"
              rel="noopener noreferrer">
              <img
                className={
                  isMobile ? "chapperone-logo-mobile" : "reallymoving-logo"
                }
                alt="Homebox"
                onClick={onLogoClick}
                src={require("../../Assets/images/Moveinout-logo.png")}
              />
            </a>
          </div>
        )}
        {isNotAnyPartner && (
          <div className="d-flex align-items-center">
            <img
              className="navbar-brand mn-navbar-icon"
              alt="MoveInOut"
              onClick={onLogoClick}
              src={require("../../Assets/images/Moveinout-logo.png")}
            />
          </div>
        )}

        {!props.noLoginButton && (
          <div className="ml-auto">
            {dashboard || TokenValidation() ? (
              <div className="mn-navbar-dashboard-wrapper">
                {window.location.pathname !== "/dashboard" && (
                  <Link
                    to="/dashboard"
                    className="mn-navbar-Link"
                    style={{ color: "#000" }}>
                    Dashboard
                  </Link>
                )}

                {!isDashboardError && (
                  <button
                    className="logout-btn "
                    style={{
                      border: `1 px solid ${colors.typography[500]}`,
                    }}>
                    <div className="center-btn" onClick={() => onLogout()}>
                      <img
                        className="login-icon"
                        alt="Logout"
                        src={require("../../Assets/images/logout-icon.svg")}
                      />
                      <span
                        className="st-navbar-login logout-btn-dashboard"
                        style={{
                          ...typography.body2[400],
                          color: colors.typography[1100],
                        }}>
                        Log out
                      </span>
                    </div>
                  </button>
                )}
              </div>
            ) : (
              <div onClick={() => setLoginShow(true)}>
                <img
                  className="login-icon pb-1"
                  alt="LogIn"
                  src={require("../../Assets/images/login-icon.svg")}
                />
                <span className="mn-navbar-login">Login</span>
              </div>
            )}
          </div>
        )}
      </nav>
    </>
  );
};

export default withRouter(Navbar);
